import { render, staticRenderFns } from "./DoctorModal__Style#Drawer.vue?vue&type=template&id=19f1a0c8&scoped=true&"
import script from "./DoctorModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./DoctorModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./DoctorModal__Style#Drawer.vue?vue&type=style&index=0&id=19f1a0c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f1a0c8",
  null
  
)

export default component.exports